var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getCurrentSenior } from 'globals/global.functions';
import { GET_ASSESSMENT, GET_LOADING_STATUS, } from 'pages/WCPages/Assessments/Assessments.action';
import { showError } from 'store/commonReducer/common.action';
import { getAllCaregiverListServiceAdmin, getAssessmentHistoryService, getCaregiverAssessmentService, } from './caregiverAssessment.service';
import { hideApplicationLoader, showApplicationLoader, } from 'common/ApplicationLoader';
export var GET_ALL_CAREGIVER_LIST = 'GET_ALL_CAREGIVER_LIST';
export var GET_ALL_CAREGIVER_LIST_SUCCESS = 'GET_ALL_CAREGIVER_LIST_SUCCESS';
export var GET_ALL_CAREGIVER_SEARCH_LIST = 'GET_ALL_CAREGIVER_SEARCH_LIST';
export var UPDATE_ALL_CAREGIVER_LIST_PAGE_NUMBER = 'UPDATE_ALL_CAREGIVER_LIST_PAGE_NUMBER';
export var SET_ALL_CG_FILTER_TYPE = 'SET_ALL_CG_FILTER_TYPE';
export var getCaregiverAssessment = function (caregiverId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var seniorID, lastEvaluatedKey, param, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: GET_LOADING_STATUS, payload: true });
                seniorID = getCurrentSenior().seniorID;
                lastEvaluatedKey = getState().assessments.history.lastEvaluatedKey;
                param = {
                    senior_id: seniorID,
                    caregiver_id: caregiverId,
                };
                if (lastEvaluatedKey) {
                    param.last_evaluated_key = lastEvaluatedKey;
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, getCaregiverAssessmentService(param, getState)];
            case 2:
                response = _a.sent();
                dispatch({ type: GET_LOADING_STATUS, payload: false });
                dispatch({
                    type: GET_ASSESSMENT,
                    payload: __assign({}, response),
                });
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                dispatch({ type: GET_LOADING_STATUS, payload: false });
                dispatch(showError(error_1));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var getCaregiverAssessmentHistory = function (data) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var params, response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                params = {
                    sent_at: data
                };
                return [4 /*yield*/, getAssessmentHistoryService(params)];
            case 1:
                response = _a.sent();
                dispatch({ type: GET_LOADING_STATUS, payload: false });
                dispatch({
                    type: GET_ASSESSMENT,
                    payload: __assign({}, response),
                });
                return [2 /*return*/, response];
            case 2:
                error_2 = _a.sent();
                dispatch({ type: GET_LOADING_STATUS, payload: false });
                dispatch(showError(error_2));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getAllCaregiverListAdmin = function (searchQueryFromParam, lastEvaluatedKey, showLoader, cgValue, page) {
    if (searchQueryFromParam === void 0) { searchQueryFromParam = ''; }
    if (lastEvaluatedKey === void 0) { lastEvaluatedKey = ''; }
    if (showLoader === void 0) { showLoader = false; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, caregiverListState, cgValue, searchQuery, params, response, error_3;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    state = getState();
                    caregiverListState = ((_a = state === null || state === void 0 ? void 0 : state.common) === null || _a === void 0 ? void 0 : _a.allcaregiverList) || {};
                    cgValue = getState().common.allcaregiverList.cgValue;
                    searchQuery = searchQueryFromParam || caregiverListState.searchQuery || '';
                    if (showLoader) {
                        dispatch(showApplicationLoader());
                    }
                    dispatch({ type: GET_ALL_CAREGIVER_LIST });
                    params = {};
                    if (lastEvaluatedKey) {
                        params.last_evaluated_key = lastEvaluatedKey;
                    }
                    if (searchQuery) {
                        params.search_by_name = searchQuery;
                    }
                    if (cgValue && cgValue !== 'All CG Types') {
                        params.caregiver_type = cgValue;
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getAllCaregiverListServiceAdmin(params)];
                case 2:
                    response = _d.sent();
                    dispatch({
                        type: GET_ALL_CAREGIVER_LIST_SUCCESS,
                        payload: {
                            data: ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.caregivers) || [],
                            lastEvaluatedKey: (response === null || response === void 0 ? void 0 : response.lastEvaluatedKey) || '',
                        },
                    });
                    return [2 /*return*/, { data: ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.caregivers) || [] }];
                case 3:
                    error_3 = _d.sent();
                    dispatch(showError(error_3));
                    dispatch(hideApplicationLoader());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var updateAllCaregiverListPageNumber = function (value) { return function (dispatch) {
    dispatch({ type: UPDATE_ALL_CAREGIVER_LIST_PAGE_NUMBER, payload: value });
}; };
export var getAllCaregiverListSuccess = function (tableData) { return function (dispatch) {
    var data = tableData.data;
    dispatch({
        type: GET_ALL_CAREGIVER_LIST_SUCCESS,
        payload: {
            data: data,
        },
    });
}; };
